module.exports = __webpack_public_path__ + "static/img/px.c72f4030.svg";